import BridgeScreen from 'pages/Bridge'
import CommunityHub from 'pages/CommunityHub'
import DeveloperHubNew from 'pages/DeveloperHubNew'
import EcosystemScreen from 'pages/EcosystemScreen'
import EcosystemScreenNew from 'pages/EcosystemScreenNew'
import EventScreen from 'pages/EventScreen'
import EventScreenNew from 'pages/EventScreenNew'
import GatewayScreen from 'pages/Gateway'
import GetStartedScreen from 'pages/GetStarted'
import HomeNew from 'pages/HomeScreenNew'
import HubScreen from 'pages/HubScreen'
import MasternodeNew from 'pages/MasternodeNew'
import NetworkScreen from 'pages/NetworkScreen'
import StableCoinScreen from 'pages/StableCoinScreen'
import UtilityScreen from 'pages/UtilityScreen'
import VictionWallet from 'pages/VicitonWallet'
import VictionDA from 'pages/VictionDA'
import ConsumerScreen from 'pages/VictionProject/ConsumerScreen'
import DefiScreen from 'pages/VictionProject/DefiScreen'
import GamingScreen from 'pages/VictionProject/GamingScreen'
import WorldWideChain from 'pages/WorldWideChain'

const { default: HomeScreen } = require('pages/HomeScreen')

const arrRouter = [
  {
    path: '/',
    element: <HomeNew />,
  },
  {
    path: '/masternode',
    element: <MasternodeNew />,
  },
  {
    path: '/defi',
    element: <DefiScreen />,
  },
  {
    path: '/event',
    element: <EventScreenNew />,
    // element: <EventScreen />,
  },
  {
    path: '/ecosystem',
    element: <EcosystemScreenNew />,
  },
  {
    path: '/community-hub',
    element: <CommunityHub />,
    // element: <HubScreen />,
  },
  {
    path: '/consumer-app',
    element: <ConsumerScreen />,
  },
  {
    path: '/gaming',
    element: <GamingScreen />,
  },
  {
    path: '/wallet',
    element: <VictionWallet />,
  },
  {
    path: '/world-wide-chain',
    element: <WorldWideChain />,
  },
  {
    path: '/viction-da',
    element: <VictionDA />,
  },
  {
    path: '/stablecoins',
    element: <StableCoinScreen />,
  },
  {
    path: '/bridge',
    element: <BridgeScreen />,
  },
  {
    path: '/gateway',
    element: <GatewayScreen />,
  },
  {
    path: '/get-started',
    element: <GetStartedScreen />,
  },
  {
    path: '/utility',
    element: <UtilityScreen />,
  },
  {
    path: '/developer-hub',
    element: <DeveloperHubNew />,
  },
]

export { arrRouter }
